import { Animation } from '../components/animation'

export function servicesCategory() {
    const animation = new Animation;

    const servicesCategoryBtn = document.querySelectorAll('.js-servicesCategoryShow');

    servicesCategoryBtn.forEach( item => {

        item.addEventListener('click', function() {
            this.classList.toggle('is-active');
            this.parentNode.classList.toggle('is-active');

            let text = this.classList.contains('is-active') ? 'Скрыть подробности' : 'Подробнее';
            this.textContent = text;

            if (!this.classList.contains('is-active')) {
                let fixidHeight = document.querySelector('[am-fixed]').clientHeight;
                animation.scroll(this.parentNode.parentNode, fixidHeight);
            }
        });
    })

}